<template>
    <div class="@container/controls relative z-1 mb-8">
        <div class="flex flex-col-reverse @4xl:items-center @4xl/controls:flex-row @4xl/controls:gap-x-8 @4xl/controls:justify-between">
            <div class="flex flex-col gap-y-2 @2xl/controls:flex-row @2xl/controls:gap-x-4 @3xl/controls:grow @4xl/controls:gap-x-2">
                <slot name="left"></slot>
            </div>
            <div class="mb-4 @4xl/controls:mb-0">
                <slot name="right"></slot>
            </div>
        </div>
    </div>

</template>

<script setup>
</script>
